// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ViewMessage-root-lWPEw {
	padding-left: 20px;
	padding-right: 20px;
}

.ViewMessage-container-FO_8m {
	margin: 0px auto;
	padding-top: 30px;
	max-width: var(--max-content-width);
}

a,
a:hover {
	color: var(--primary-link-foreground);
}

.ViewMessage-bgColor-l3fva {
	width: 100%;
	background: #F7FAFF;
}

@media (max-width: 1023px) and (min-width: 768px) {
	.ViewMessage-bgColor-l3fva {
		padding: 0 10px;
	}
}

@media (max-width: 767px) {
	.ViewMessage-bgColor-l3fva {
		padding: 0 10px;
	}
}`, "",{"version":3,"sources":["webpack://./src/routes/viewMessage/ViewMessage.css"],"names":[],"mappings":"AAAA;CACC,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,gBAAgB;CAChB,iBAAiB;CACjB,mCAAmC;AACpC;;AAEA;;CAEC,qCAAqC;AACtC;;AAEA;CACC,WAAW;CACX,mBAAmB;AACpB;;AAEA;CACC;EACC,eAAe;CAChB;AACD;;AAEA;CACC;EACC,eAAe;CAChB;AACD","sourcesContent":[".root {\n\tpadding-left: 20px;\n\tpadding-right: 20px;\n}\n\n.container {\n\tmargin: 0px auto;\n\tpadding-top: 30px;\n\tmax-width: var(--max-content-width);\n}\n\na,\na:hover {\n\tcolor: var(--primary-link-foreground);\n}\n\n.bgColor {\n\twidth: 100%;\n\tbackground: #F7FAFF;\n}\n\n@media (max-width: 1023px) and (min-width: 768px) {\n\t.bgColor {\n\t\tpadding: 0 10px;\n\t}\n}\n\n@media (max-width: 767px) {\n\t.bgColor {\n\t\tpadding: 0 10px;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `ViewMessage-root-lWPEw`,
	"container": `ViewMessage-container-FO_8m`,
	"bgColor": `ViewMessage-bgColor-l3fva`
};
module.exports = ___CSS_LOADER_EXPORT___;
